// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__3hbGO","isStartpage":"App_isStartpage__1Q6rs"};